
<template>
    <div class="handForm">
        <el-form :model="formData" ref="formData" label-width="130px" :rules="rules">
            <div class="title">一、术前准备及交接</div>
            <el-form-item label="1.一般准备：">
                <el-checkbox-group v-model="formData.generalPreparation">
                    <el-checkbox label="1" :disabled="listDisable">备皮</el-checkbox>
                    <el-checkbox label="2" :disabled="listDisable">备血</el-checkbox>
                    <el-checkbox label="3" :disabled="listDisable">皮试</el-checkbox>
                </el-checkbox-group>
                <el-input :disabled="listDisable" v-model.trim="formData.skinTest" style="width:60%;" placeholder="请输入备注"></el-input>
            </el-form-item>
            <el-form-item label="2.肠道准备：">
                <el-checkbox-group v-model="formData.bowelPreparation">
                    <el-checkbox :disabled="listDisable" label="1">服药</el-checkbox>
                    <el-input :disabled="listDisable" v-model.trim="formData.takeMedicine" style="width:20%;" placeholder="请输入备注"></el-input>
                    <el-checkbox :disabled="listDisable" label="2">禁食</el-checkbox>
                    <el-checkbox :disabled="listDisable" label="3">禁水</el-checkbox>
                    <el-checkbox :disabled="listDisable" label="4">其他</el-checkbox>
                    <el-input :disabled="listDisable" v-model.trim="formData.bowelPreparationOther" style="width:60%;" placeholder="请输入其他"></el-input>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="3.置管情况：">
                <el-checkbox-group v-model="formData.catheterization">
                    <el-checkbox :disabled="listDisable" label="1">导尿管</el-checkbox>
                    <el-checkbox :disabled="listDisable" label="2">其他</el-checkbox>
                </el-checkbox-group>
                <el-input :disabled="listDisable" v-model.trim="formData.catheterizationOther" style="width:60%;" placeholder="请输入其他"></el-input>
            </el-form-item>
            <el-form-item label="4.生命体征：">
                <span class="people">
                    <span>时间:</span>
                    <el-time-picker @input="testSX" format="HH:mm" value-format="HH:mm" :disabled="listDisable" v-model="formData.vitalSignsPreoperative.time" style="width:150px;margin:0 5px;" placeholder="请选择时间点"></el-time-picker>
                    <!-- <el-input :disabled="listDisable" v-model.trim="formData.vitalSignsPreoperative.time" style="width:150px;margin:0 5px;" placeholder="请输入"></el-input> -->
                </span>
                <span class="people">
                    <span>T</span>
                    <el-input :disabled="listDisable" v-model.trim="formData.vitalSignsPreoperative.centigrade " style="width:150px;margin:0 5px;" placeholder="请输入"></el-input><span>℃</span>
                </span>
                <span class="people">
                    <span>P</span>
                    <el-input :disabled="listDisable" v-model.trim="formData.vitalSignsPreoperative.pulse" style="width:150px;margin:0 5px;" placeholder="请输入"></el-input><span>次/分</span>
                </span>
                <span class="people">
                    <span>R</span>
                    <el-input :disabled="listDisable" v-model.trim="formData.vitalSignsPreoperative.breathe" style="width:150px;margin:0 5px;" placeholder="请输入"></el-input><span>次/分</span>
                </span>
                <span class="people">
                    <span>BP</span>
                    <el-input :disabled="listDisable" v-model.trim="formData.vitalSignsPreoperative.bloodPressure" style="width:150px;margin:0 5px;" placeholder="请输入"></el-input><span>mmHg</span>
                </span>
            </el-form-item>
            <el-form-item label="5.皮肤情况：">
                <el-checkbox-group v-model="formData.skinPreoperative">
                    <el-checkbox :disabled="listDisable" label="1">正常</el-checkbox>
                    <el-checkbox :disabled="listDisable" label="2">其他</el-checkbox>
                </el-checkbox-group>
                <el-input :disabled="listDisable" v-model.trim="formData.skinPreoperativeOther" style="width:60%;" placeholder="请输入其他"></el-input>
            </el-form-item>
            <el-form-item label="6.带药、物：">
                <div>
                    <el-input :disabled="listDisable" v-model.trim="formData.drugPreoperative" style="width:60%;" placeholder="请输入药品"></el-input>
                </div>
                <div>
                    <el-input :disabled="listDisable" v-model.trim="formData.articlePreoperative" style="width:60%;" placeholder="请输入物品"></el-input>
                </div>
            </el-form-item>
            <el-form-item label="7.手术名称(术式)：">
                <el-input :disabled="listDisable" v-model.trim="formData.operationNamePreoperative" style="width:60%;" placeholder="请输入其他"></el-input>
                <el-checkbox-group v-model="formData.positionPreoperative">
                    <el-checkbox :disabled="listDisable" label="1">手术部位标识</el-checkbox>
                </el-checkbox-group>
            </el-form-item>

            <div style="display:flex;" class="sign">
                <el-form-item label="签名">
                    <el-input disabled v-model.trim="formData.preoperativeSignature" placeholder="请输入签名"></el-input>
                </el-form-item>
                <el-form-item label="交接患者核对签名" prop="preoperativeNurseNo" label-width="150px">
                    <el-select clearable :disabled="listDisable" @focus="focus" default-first-option filterable v-model="formData.preoperativeNurseNo" @input="testSX" :filter-method="empMatch">
                        <el-option v-for="(item) in newLists" :key="item.id" :label="item.userName" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <el-form-item label="备注">
                <el-input :disabled="listDisable" v-model.trim="formData.preoperativeRemarks" style="width:60%;" placeholder="请输入备注"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button :disabled="buttonDisabled" size="small" type="primary" class="sureButton" @click="sureHand('formData')">术前准备交接</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import pinyin from 'pinyin-match'
import { log } from 'util';
import { mapState, mapGetters } from 'vuex'
export default {
    props: ['formData'],
    data() {
        return {
            newLists: [],
            rules: {
                preoperativeNurseNo: [{ required: true, message: "请核对签字", trigger: "blur", }],
            },
            listDisable: false,
            buttonDisabled: false,
        }
    },
    computed: {
        ...mapGetters(['nurseNoList',]),
    },
    watch: {
        $route(to, from) {
            // if (this.activatedFlag) {
            this.focus()
            this.query()
            // }
        },
    },
    created() {
        this.focus()
        this.query()
    },
    methods: {
        init() {
            this.isTrue('skinTest')
            this.isTrue('bowelPreparationOther')
            this.isTrue('catheterizationOther')
            this.isTrue('takeMedicine')
            this.isFlag('time')
            this.isFlag('centigrade')
            this.isFlag('pulse')
            this.isFlag('breathe')
            this.isFlag('bloodPressure')
            this.isTrue('skinPreoperativeOther')
            this.isTrue('drugPreoperative')
            this.isTrue('articlePreoperative')
            this.isTrue('operationNamePreoperative')
            this.isTrue('preoperativeRemarks')
        },
        query() {
            this.passData = this.$route.params
        },
        testSX() {
            this.$forceUpdate()
        },
        focus() {
            setTimeout(() => {
                this.newLists = this.$store.getters.nurseNoList;
            }, 100);
        },
        empMatch(val) {
            this.newList3 = _g.paramMatch(this.nurseNoList, this.newList3, val, 'userName')
        },
        isTrue(val) {
            if (this.formData[val] == '' || this.formData[val] == undefined) {
                this.formData[val] = '/'
            }
        },
        isFlag(val) {
            if (this.formData.vitalSignsPreoperative[val] == '' || this.formData.vitalSignsPreoperative[val] == undefined) {
                this.formData.vitalSignsPreoperative[val] = '/'
            }
        },

        handMethod() {
            this.listDisable = true
        },
        toHand() {
            this.listDisable = false
        },
        buttonTrue() {
            this.buttonDisabled = true
        },
        buttonFlase() {
            this.buttonDisabled = false
        },
        // 确定交接操作
        sureHand(formData) {
            this.$refs.formData.validate((valid) => {
                if (valid) {
                    if (Lockr.get("skinEmpId") == this.formData.preoperativeNurseNo) {// id相同是要确认交接
                        if (this.formData.auditType == 1) {
                            // 如果是1 术前审核已提交 对接第二模块术后情况
                            this.$parent.secondMethod()
                            // 同时第一模块的不是自己录入的不可以修改
                            this.listDisable = true
                            this.formData.auditType = 2
                        } else if (this.formData.auditType == 0) {
                            _g.toast('error', '术前准备还未确认交接！！！')
                        } else {
                            _g.toast('error', '术前准备已经完成交接！！！')
                        }
                    } else if (Lockr.get("skinEmpId") != this.formData.preoperativeNurseNo) {// id不同是要提出交接
                        // console.log(this.formData);
                        this.formData.generalPreparation = this.formData.generalPreparation.toString()
                        this.formData.bowelPreparation = this.formData.bowelPreparation.toString()
                        this.formData.catheterization = this.formData.catheterization.toString()
                        this.formData.skinPreoperative = this.formData.skinPreoperative.toString()
                        this.formData.positionPreoperative = this.formData.positionPreoperative.toString()
                        this.formData.anesthesiaMode = this.formData.anesthesiaMode.toString()
                        this.formData.awarenessState = this.formData.awarenessState.toString()
                        this.formData.decubitusPosition = this.formData.decubitusPosition.toString()
                        this.formData.skinPostoperative = this.formData.skinPostoperative.toString()
                        this.formData.psychologicalNursing = this.formData.psychologicalNursing.toString()
                        this.formData.diet = this.formData.diet.toString()
                        this.formData.position = this.formData.position.toString()
                        this.formData.incision = this.formData.incision.toString()
                        this.formData.conduit = this.formData.conduit.toString()
                        this.formData.propagandaEducation = this.formData.propagandaEducation.toString()
                        this.formData.createBy = Lockr.get('skinEmpId');
                        this.formData.auditType = 1
                        this.formData.leaveObserve = Lockr.get('leaveObserve');
                        this.nurseNoList.forEach(item => {
                            if (item.id == this.formData.preoperativeNurseNo) {
                                this.formData.preoperativeNurseName = item.userName
                            }
                        });
                        if (this.formData.code == 0) {
                            this.formData.leaveObserveId = this.passData.id;
                            api.requestQuiet("/leaveObserve/createHandoverRecord", this.formData, (res) => {
                                if (res.result == true) {
                                    _g.toast("success", '添加成功');
                                    router.push({ path: '/observation/observation', query: { code: 0 }, })
                                } else {
                                    _g.toast("error", res.errMsg);
                                }
                            }, (err) => { });
                        } else if (this.formData.code == 1) {
                            this.formData.leaveObserveId = this.formData.leaveObserveId;
                            api.requestQuiet("/leaveObserve/updateHandoverRecord", this.formData, (res) => {
                                if (res.result == true) {
                                    _g.toast("success", '修改成功');
                                    router.push({ path: '/observation/observation', query: { code: 0 } })
                                } else {
                                    _g.toast("error", res.errMsg);
                                }
                            }, (err) => { });
                        }
                    }

                } else {
                    _g.toast("warning", "请核对签字");
                    return false;
                }
            })
        },
    }
}
</script>
<style scoped>
.handForm {
  border: 1px solid #eee;
  border-radius: 4px;
  margin-top: 10px;
  background: #eee;
}
.people {
  margin-right: 20px;
}
.handForm >>> .el-form-item {
  margin-bottom: 0px !important;
}
.handForm >>> .el-form-item__error {
  position: absolute;
  left: 0;
  top: -16px;
}
</style>



